<template>
  <div>
    <accordion
      v-for="(investimento, i) in investimentos"
      :key="`tabela_investimento_${rubrica}_${i}`"
      :id="`sub_investimento${rubrica}_${i}`"
      :title="investimento.recebedora"
      sub
      :accordion="`sub_investimento${rubrica}_${i}`"
      visible
      classTitulo="font-bold border-grey-300"
      variante="transparent"
    >
      <template #append-title>
        <b-badge v-if="calcularRestante(investimento) == 0" variant="success" class="ml-2"
          >Investimento finalizado</b-badge
        >
        <b-badge v-if="calcularRestante(investimento) > 0" variant="danger" class="ml-2"
          >Investimento não finalizado</b-badge
        >
      </template>
      <investimento-t-r
        :rubrica="rubrica"
        :investimento="investimento"
        :endpoint="endpoint"
      />
    </accordion>
  </div>
</template>
<script>
import investimentoTR from "./investimentoTR";
import Accordion from "@/components/card/Accordion";
export default {
  props: {
    investimentos: {
      required: true,
    },
    rubrica: {
      required: true,
    },
    endpoint: {},
  },
  components: {
    Accordion,
    investimentoTR,
  },
  methods: {
    calcularRestante(investimento) {
      return (
        (investimento ? investimento.totalPrevisto : 0) -
        (investimento ? investimento.totalAlocado : 0)
      );
    },
  },
};
</script>
<style></style>
